import { AsyncPipe, NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LogoComponent } from '@core/layout/components/logo/logo.component';
import { TenantLogadoNavbarComponent } from '@core/layout/components/navbar/tenant-logado-navbar/tenant-logado-navbar.component';
import { UsuarioLogadoNavbarComponent } from '@core/layout/components/navbar/usuario-logado-navbar/usuario-logado-navbar.component';
import { MenuService } from '@core/layout/services/menu.service';
import { NotificationService } from '@core/services/notification.service';
import { UsuariosService } from '@modules/usuarios/services/usuarios.service';
import { IconComponent } from '@shared/components/icon/icon.component';
import { LogoEmpresaComponent } from '@shared/components/logo-empresa/logo-empresa.component';
import { AppButtonDirective } from '@shared/ui/button/app-button.directive';
import { DropdownComponent } from '@shared/ui/dropdown/dropdown.component';
import { map, shareReplay } from 'rxjs';
import { ModalTenentService } from '../services/modal-tenent.service';
import { NotificationListComponent } from './notification-list/notification-list.component';

@Component({
  selector: 'app-navbar',
  imports: [
    AsyncPipe,
    IconComponent,
    AppButtonDirective,
    LogoComponent,
    LogoEmpresaComponent,
    UsuarioLogadoNavbarComponent,
    TenantLogadoNavbarComponent,
    NgClass,
    DropdownComponent,
    NotificationListComponent,
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  protected menuService = inject(MenuService);

  private readonly _notificationService = inject(NotificationService);
  private readonly _usuariosService = inject(UsuariosService);
  private readonly _modalTenentService = inject(ModalTenentService);

  protected readonly unreadCount$ = this._notificationService.notifications$.pipe(
    map((notifications) => notifications.filter((n) => !n.lida).length),
  );

  protected readonly usuarioLogado$ = this._usuariosService.usuarioLogado$.pipe(shareReplay(1));

  toggleSidebar(): void {
    this.menuService.toggleSidebar();
  }

  toggleMobileMenu(): void {
    this.menuService.showMobileMenu = !this.menuService.showMobileMenu;
  }

  abrirTrocaTenant(): void {
    this._modalTenentService.toggleModal();
  }
}
